/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { type ViewStyle } from 'react-native';
import { BlockHeading } from '../../../shared/surface-cards/BlockHeading';

export function ReportsBlockHeading(props: {
  label: string;
  description?: string;
  /** Primera sección bajo el encabezado de la vista: sin margen superior extra. */
  noTopMargin?: boolean;
  style?: ViewStyle;
}) {
  return <BlockHeading {...props} />;
}
